module.exports = __webpack_public_path__ + "img/creators_large.ef4381ed.png";